
    import SlideScroll from '@/components/Utils/SlideScroll';
    import EducationCard from '@/components/Education/EducationCard';
    import SlideScrollItem from '@/components/Utils/SlideScrollItem';

    export default {
        name: 'EducationScroll',

        components: {
            SlideScrollItem,
            SlideScroll,
            EducationCard,
        },

        props: {
            articles: {
                type: Array,
                default: () => ([]),
            },
        },

        data() {
            return {
            };
        },

        methods: {
            onSelectArticle(article) {
                this.$emit('select', article);
            },
        },
    };
